import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import FaviconSwapper from "@/components/FaviconSwapper";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#fdfbf7]">
      <FaviconSwapper />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
